import { firestore as db, storage } from "./firebase";
import { StatementList } from "./statements";

export const COLLECTION_STATEMENTS: string = "statements";
const storageFolder = "statements";

export interface StatementPopular {
    id: string;
    title: string;
    status: string;
    slug: string;
    imgUrl: any;
};

export async function getStatementsPopular(): Promise<StatementPopular[]> {
  const data = await db
    .collection(COLLECTION_STATEMENTS)
    .orderBy("commentCount", "desc")
    .orderBy("followerCount", "desc")
    .where("status", "==", "published")
    .limit(3)
    .get();

  let statements: StatementPopular[] = [];

  data.forEach((doc) => statements.push({ ...doc.data() } as any));

  // Get imageUrl for statement
  for (let index = 0; index < statements.length; index++) {
    const imgUrl = await determineBackgroundUrl(statements[index].id)
    statements[index].imgUrl = imgUrl;
  }

  return statements;
}

export function mapToListItem(
  statement: StatementPopular
): StatementList {
  return {
    id: statement.id,
    slug: statement.slug,
    title: statement.title,
    imgUrl: statement.imgUrl,
  };
}

async function determineBackgroundUrl(id: any) {
  try {
    const firebaseUrl = await storage
      .ref(storageFolder)
      .child(id)
      .getDownloadURL();

      return firebaseUrl;
  } catch {
    return null;
  }
}
